import { useId } from 'react';
import './GroupBracketFlow.css';

export default function GroupBracketFlow({ group, card, kz }) {
  const marker = useId().replace(/:/g, '');
  const five = group.teams.length === 5;
  const shift = five ? 320 : 0;
  const positions = {
    p: { x: 0, y: 280 },
    w1: { x: shift, y: 40 }, w2: { x: shift, y: 280 },
    wf: { x: shift + 320, y: 160 },
    l1: { x: shift + 320, y: 660 },
    l2: { x: shift + 640, y: 660 },
    lf: { x: shift + (five ? 960 : 640), y: 660 },
  };
  const nodes = group.matches.map((match) => ({ match, ...positions[match.id.split('-').pop()] }));
  const byId = Object.fromEntries(nodes.map((node) => [node.match.id, node]));
  const width = shift + (five ? 1540 : 1220);
  const edges = nodes.flatMap((target) => [target.match.aSource, target.match.bSource].flatMap((source, side) => {
    const origin = byId[source.match];
    if (!origin) return [];
    const drop = source.outcome === 'loser';
    const endX = target.x, endY = target.y + 75 + side * 50;
    const startX = origin.x + 260, startY = origin.y + 100;
    const routeY = 530 + nodes.findIndex((node) => node.match.id === origin.match.id) * 20;
    const path = drop
      ? `M ${origin.x + 130} ${origin.y + 200} V ${routeY} H ${endX - 30 - side * 12} V ${endY} H ${endX}`
      : `M ${startX} ${startY} H ${startX + 30} V ${endY} H ${endX}`;
    return [{ id: `${target.match.id}-${side}`, path, drop, label: `${drop ? 'Проигравший' : 'Победитель'}: ${origin.match.label} → ${target.match.label}` }];
  }));
  return <div>
    <p className="nova-flow-legend"><span>→ {kz ? 'Жеңімпаз' : 'Победитель'}</span><span className="nova-flow-legend-loss">⇢ {kz ? 'Жеңілген команда төменгі торға өтеді' : 'Проигравший переходит в нижнюю сетку'}</span></p>
    <div className="nova-flow-scroll" tabIndex={0} role="region" aria-label={`Схема переходов группы ${group.id}`}>
      <div className="nova-flow-canvas" style={{ width }}>
        <h4 className="nova-flow-heading" style={{ top: 0 }}>{kz ? 'Жоғарғы тор' : 'Верхняя сетка'}</h4>
        <h4 className="nova-flow-heading" style={{ top: 615 }}>{kz ? 'Төменгі тор' : 'Нижняя сетка'}</h4>
        <svg className="nova-flow-lines" width={width} height="900" aria-label="Переходы победителей и проигравших">
          <defs>{['win', 'loss'].map((kind) => <marker key={kind} id={`${marker}-${kind}`} markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto"><path d="M0 0 L8 4 L0 8 Z" fill={kind === 'win' ? '#e6b73c' : '#a78bfa'} /></marker>)}</defs>
          {edges.map((edge) => <path key={edge.id} d={edge.path} fill="none" stroke={edge.drop ? '#a78bfa' : '#e6b73c'} strokeWidth="2" strokeDasharray={edge.drop ? '6 5' : undefined} markerEnd={`url(#${marker}-${edge.drop ? 'loss' : 'win'})`}><title>{edge.label}</title></path>)}
          {[['wf', '1'], ['lf', '2']].map(([key, place]) => {
            const node = positions[key];
            return <path key={place} d={`M ${node.x + 260} ${node.y + 100} H ${node.x + 300}`} fill="none" stroke="#e6b73c" strokeWidth="2" markerEnd={`url(#${marker}-win)`} />;
          })}
        </svg>
        {nodes.map((node) => <div key={node.match.id} className="nova-flow-node" style={{ left: node.x, top: node.y }}>{card(node.match)}</div>)}
        {[['wf', '1'], ['lf', '2']].map(([key, place]) => <div key={place} className="nova-flow-qualifier" style={{ left: positions[key].x + 310, top: positions[key].y + 70 }}>{place}-е место<br /><span>→ Плей-офф</span></div>)}
      </div>
    </div>
  </div>;
}
